import { config } from '../config';
import { ProjectConfig } from '../../../types/global.types';

import SolarContact from '../../apps/SolarContact';
import SolarCalculator from '../../apps/SolarCalculator';

export const apps: ProjectConfig = {
  'contact': SolarContact,
  'calculator': SolarCalculator
};

const solar = window.solar;

export const getProjectSubDomain = (): string => {
  if (solar) {
    if (solar.context === 'contact') {
      return 'contact';
    }
    if (solar.context === 'calculator') {
      return 'calculator';
    }
  }

  if (config.ENV === 'local' || config.ENV === 'dev' || config.ENV === 'test') {
    const devUrl = window.location.hash.substring(2, window.location.hash.length);
    const devDomain = devUrl.split('/')[0];

    if (apps[devDomain]) {
      return devDomain;
    }
  }

  return 'contact';
};
